import React from 'react'

function OurServices() {
  return (
    <div>
      <div
  className="services-style-one-area default-padding"
  style={{ background: "url(static/img/shape/12.png)" }}
>
  <div className="container">
    <div className="row">
      <div className="col-xl-6 offset-xl-3 col-lg-8 offset-lg-2">
        <div className="site-heading text-center">
          <h4 className="sub-title">Our Services</h4>
          <h2 className="title">Empower your business with our services.</h2>
        </div>
      </div>
    </div>
  </div>
  <div className="container">
    <div className="row">
      <div className="col-lg-12">
        <div className="services-style-one-items">
          {/* Single Item */}
          <div className="services-style-one-item out">
            <div className="icon">
              <img src="static/img/icon/5.png" alt="Img Not Found" />
            </div>
            <div className="content">
              <h4>
                <a href="services-details.html">Web Development </a>
              </h4>
              <p>
                Seeing rather her you not esteem men settle genius excuse. Deal
                say over you age devonshire Comparison new ham melancholy son
                themselves instrument out reasonably.
              </p>
            </div>
            <div className="button">
              <a className="btn" href="services-details.html">
                <i className="fas fa-arrow-right" />
              </a>
            </div>
            <span>01</span>
          </div>
          {/* End Single Item */}
          {/* Single Item */}
          <div className="services-style-one-item">
            <div className="icon">
              <img src="static/img/icon/6.png" alt="Img Not Found" />
            </div>
            <div className="content">
              <h4>
                <a href="services-details.html">
                  Custom Software <br /> Development{" "}
                </a>
              </h4>
              <p>
                Seeing rather her you not esteem men settle genius excuse. Deal
                say over you age devonshire Comparison new ham melancholy son
                themselves instrument out reasonably.
              </p>
            </div>
            <div className="button">
              <a className="btn" href="services-details.html">
                <i className="fas fa-arrow-right" />
              </a>
            </div>
            <span>02</span>
          </div>
          {/* End Single Item */}
          {/* Single Item */}
          <div className="services-style-one-item">
            <div className="icon">
              <img src="static/img/icon/7.png" alt="Img Not Found" />
            </div>
            <div className="content">
              <h4>
                <a href="services-details.html">Mobile App Development</a>
              </h4>
              <p>
                Seeing rather her you not esteem men settle genius excuse. Deal
                say over you age devonshire Comparison new ham melancholy son
                themselves instrument out reasonably.
              </p>
            </div>
            <div className="button">
              <a className="btn" href="services-details.html">
                <i className="fas fa-arrow-right" />
              </a>
            </div>
            <span>03</span>
          </div>
          {/* End Single Item */}
          {/* Single Item */}
          <div className="services-style-one-item">
            <div className="icon">
              <img src="static/img/icon/7.png" alt="Img Not Found" />
            </div>
            <div className="content">
              <h4>
                <a href="services-details.html">UI/UX Design</a>
              </h4>
              <p>
                Seeing rather her you not esteem men settle genius excuse. Deal
                say over you age devonshire Comparison new ham melancholy son
                themselves instrument out reasonably.
              </p>
            </div>
            <div className="button">
              <a className="btn" href="services-details.html">
                <i className="fas fa-arrow-right" />
              </a>
            </div>
            <span>04</span>
          </div>
          {/* End Single Item */}
        </div>
      </div>
    </div>
  </div>
</div>

    </div>
  )
}

export default OurServices
